import { Component, Input, SimpleChanges, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';

@Component({
  selector: 'rr-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    }
  ]
})
export class SelectComponent implements ControlValueAccessor {
  @Input() options: Array<any> = [];
  @Input() label: string = '';
  control: FormControl = new FormControl();
  @Input() placeholder: string = '';
  @Input() optionName: string = '';
  @Input() optionValue: string = '';

  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() preselectedValue: any = null;

  selectedName: string = '';
  selectedIcon: string = '';
  showOptions: boolean = false;
  elementWidth: string = 'auto';
  elementHeight: string = 'auto';
  errorClass: string = '';

  constructor() { }

  ngOnInit() {
    this.initializeSelectedOption();
    if (this.preselectedValue) {
      setTimeout(() => {
        this.updateSelectedOption(this.preselectedValue);
      }, 50);
    }
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
    this.control.valueChanges.subscribe(() => {
      this.checkValidation();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.initializeSelectedOption();
    }
  }

  initializeSelectedOption() {
    const selectedOption = this.options?.find(option => option[this.optionValue] === this.control.value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }
  }

  updateSelectedOption(value: any) {
    const selectedOption = this.options.find(option => option[this.optionValue] === value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }

  }

  selectOption(option: any) {
    if (option === undefined) {
      this.selectedName = '';
      this.selectedIcon = '';
      this.control.setValue(null);
      this.showOptions = false;
      return;
    }

    this.selectedName = option[this.optionName];
    this.selectedIcon = option.icon || '';
    this.showOptions = false;
    this.control.setValue(option[this.optionValue]);
    this.onTouched();
  }
  getSelectedOption() {
    return this.options.find(option => option[this.optionValue] === this.control.value);
  }
  toggleOptions(eventTarget: any) {
    if (this.disabled == true) {
      return;
    }
    this.showOptions = !this.showOptions;

    if (this.showOptions) {
      setTimeout(() => {
        const element = (eventTarget as HTMLElement).closest('.mainselect');
        if (element) {
          const width = element.clientWidth;
          let height = element.clientHeight;
          if (this.label !== '') height = height + 28;
          this.elementWidth = width + 2 + 'px';
          this.elementHeight = height + 10 + 'px';
        } else {
          this.elementWidth = 'auto';
          this.elementHeight = 'auto';
        }
      }, 0);
    }
  }

  checkValidation() {
    if (this.required) {
      if (!this.control.value) {
        this.errorClass = 'error';
        if (!this.control.hasError('required')) {
          this.control.setErrors({ required: true });
        }
      } else {
        this.errorClass = '';
        if (this.control.hasError('required')) {
          this.control.setErrors(null);
        }
      }
    }
  }

  writeValue(value: any): void {
    if (value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any): void {
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
